import React from 'react';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import { ButtonTypes, IImagePresetTypes } from '../../../../../../Interfaces/componentTypes';
import Button from '../../../../../../Components/Button/button';
import styles from './qrDialog.module.scss';

interface IProps {
    image: string,
    onDownLoad: () => void,
    onClose: () => void,
    presetData: IImagePresetTypes[],
    selectedSize: number,
    onSetImgSize: (data: IImagePresetTypes) => void,
    loading:boolean
};

const QrDialog: React.FC<IProps> = (props) => {
    const { image, onDownLoad, onClose, onSetImgSize, presetData, selectedSize,loading } = props;
    const { t } = useLanguagesHooks();

    return (
        <div className={styles.container} >
            <div className={styles.header}>
                <p>{t('My_Business.Qr.Dwld_Button_Big')}</p>
            </div>
            <div className={styles.body}>
                <div className={styles.imageBox}>
                    <img src={image} alt={`${image}.png`} />
                </div>
                <div className={styles.presetsBox}>
                    {presetData.map((item) => {
                        return (
                            <div
                                key={item.id}
                                onClick={() => selectedSize !== item.id && onSetImgSize(item)}
                                className={selectedSize === item.id ? styles.presetItemSelected : styles.presetItem}
                            >
                                <p>{item.label}</p>
                                <span>{item.sizes}</span>
                            </div>
                        )
                    })}
                </div>
                <div className={styles.buttonsRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Close')}
                        type='button'
                        onClick={onClose}
                        buttonStyle={styles.closeButton}
                    />
                    <Button
                        buttonType={ButtonTypes.Primery}
                        title={t('My_Business.Qr.Download')}
                        type='button'
                        onClick={onDownLoad}
                        isLoading={loading}
                        buttonStyle={styles.button}
                    />
                </div>
            </div>
        </div>
    )
}

export default QrDialog
